import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CurrentUserType } from "../type";

interface UserState {
    user: any;
    loading: boolean;
    error: string | null;
}
const initialState = {
    user: null,
    loading: false,
    error: null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setCurrentUser(state, action:PayloadAction<CurrentUserType>) {
            state.user = action.payload;
            state.loading = false;
            state.error = null;
        },
        setCurrentUserLoading(state, action:PayloadAction<boolean>) {
            state.loading = action.payload;
            state.error = null;
        },
        setCurrentUserError(state, action:PayloadAction<CurrentUserType>) {
            state.loading = false;
            state.error = action.payload;
        },
    },
})

export const { setCurrentUser, setCurrentUserLoading, setCurrentUserError } = userSlice.actions;
export default userSlice.reducer